// Data loading utilities for Travelogue app

export const loadDestinations = async () => {
  try {
    const response = await fetch('/data/destinations.json');
    const data = await response.json();
    return data.destinations || [];
  } catch (error) {
    console.error('Error loading destinations:', error);
    return [];
  }
};

export const loadStories = async () => {
  try {
    const response = await fetch('/data/stories.json');
    const data = await response.json();
    return data.stories || [];
  } catch (error) {
    console.error('Error loading stories:', error);
    return [];
  }
};

export const getDestinationBySlug = async (slug) => {
  const destinations = await loadDestinations();
  return destinations.find(dest => dest.slug === slug) || null;
};

export const getStoryBySlug = async (slug) => {
  const stories = await loadStories();
  return stories.find(story => story.slug === slug) || null;
};

export const filterDestinations = (destinations, searchTerm = '', selectedTags = []) => {
  return destinations.filter(destination => {
    const matchesSearch = !searchTerm || 
      destination.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      destination.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
      destination.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesTags = selectedTags.length === 0 || 
      selectedTags.some(tag => destination.tags.includes(tag));
    
    return matchesSearch && matchesTags;
  });
};

export const getUniqueTags = (destinations) => {
  const allTags = destinations.flatMap(dest => dest.tags);
  return [...new Set(allTags)].sort();
};

export const getRelatedStories = (stories, destinationSlug, limit = 3) => {
  return stories
    .filter(story => story.destinationSlug === destinationSlug)
    .slice(0, limit);
};
